

<form   *ngIf="showHeaderDetail" [formGroup]="dynaHeaderForm" autocomplete="off" novalidate="" style="margin-bottom: 10px;">
    <tabset>
        <tab  heading="Properties"  active="true">
            <div class="form-group row mt-2">
                <div style="display:none">
                    <input class="form-control form-control-sm" formControlName="name">
                </div>
                <div style="display:none">
                    <input class="form-control form-control-sm" formControlName="ID">
                </div>
                <div class="col-sm-4">
                    <label>Display Name : </label>
                </div>
                <div class="col-sm-8">
                    <input class="form-control form-control-sm" formControlName="displayName">
                </div>

                <div class="col-sm-4 mt-2">
                    <label>Mask : </label>
                </div>
                <div class="col-sm-8 mt-2">
                    <div class="input-group input-group-sm">
                        <input type="text" class="form-control form-control-sm" formControlName="maskPattern" placeholder="Pattern" aria-label="Username">
                        <span class="input-group-text">e.g:</span>
                        <input type="text" class="form-control form-control-sm" formControlName="maskValue" placeholder="Example" aria-label="Server">
                      </div>
                </div>
                <div class="col-sm-4 mt-2">
                    <label>Display Format : </label>
                </div>
                <div class="col-sm-8 mt-2">
                    <input class="form-control form-control-sm" formControlName="displayFormat">
                </div>
                <div *ngIf="isAllowSort" class="col-sm-4">
                    <label>Allow Sort : </label>
                </div>
                <div *ngIf="isAllowSort" class="col-sm-8">
                    <input class="form-check-input position-static" type="checkbox" formControlName="allowSort" style="margin-left: 0px;">
                </div>
                <div *ngIf="isAllowEdit" class="col-sm-4">
                    <label>Allow Edit : </label>
                </div>
                <div *ngIf="isAllowEdit" class="col-sm-8">
                    <input class="form-check-input position-static" type="checkbox" formControlName="isEditable" style="margin-left: 0px;">
                </div>
            </div>
        </tab>

        <tab  heading="Design">
            <div class="form-group row mt-2">
                <div *ngIf="isAdmin == true"  class="col-sm-4 mt-2">
                    <label>Width : </label>
                </div>
                <div  *ngIf="isAdmin == true" class="col-sm-8 mt-2">
                    <input class="form-control form-control-sm" formControlName="width">
                </div>
                <div style="display:none">
                    <label>Height : </label>
                </div>
                <div style="display:none">
                    <input class="form-control form-control-sm" formControlName="height">
                </div>
                <div class="col-sm-4 mt-2">
                    <label>Alignment : </label>
                </div>
                <div class="col-sm-8 mt-2">
                    <select class="form-select form-select-sm" formControlName="alignment">
                        <option [value] = "IE_ALIGNMENT.Left">Left</option>
                        <option [value] = "IE_ALIGNMENT.Middle">Middle</option>
                        <option [value] = "IE_ALIGNMENT.Right">Right</option>
                      </select> 
                </div>
            </div>
        </tab>
    </tabset>

    <div class="col-sm-12 mt-2">
        <button type="button" class="btn btn-sm btn-secondary"
            (click)="updateFormValues(dynaHeaderForm.value,'update')">Update</button>
    </div>
</form>



<!--<form *ngIf="showHeaderDetail" [formGroup]="dynaHeaderForm" autocomplete="off" novalidate=""
            style="margin-bottom: 10px;">
            <div class="form-group row">
                <div style="display:none">
                    <input class="form-control form-control-sm" formControlName="name">
                </div>
                <div style="display:none">
                    <input class="form-control form-control-sm" formControlName="ID">
                </div>
                <div class="col-sm-4">
                    <label>Display Name : </label>
                </div>
                <div class="col-sm-8">
                    <input class="form-control form-control-sm" formControlName="displayName">
                </div>
                <div class="col-sm-4 mt-2">
                    <label>Mask : </label>
                </div>
                <div class="col-sm-8 mt-2">
                    <div class="input-group input-group-sm">
                        <input type="text" class="form-control form-control-sm" formControlName="maskPattern" placeholder="Pattern" aria-label="Username">
                        <span class="input-group-text">e.g:</span>
                        <input type="text" class="form-control form-control-sm" formControlName="maskValue" placeholder="Example" aria-label="Server">
                      </div>
                </div>
                <div class="col-sm-4 mt-2">
                    <label>Display Format : </label>
                </div>
                <div class="col-sm-8 mt-2">
                    <input class="form-control form-control-sm" formControlName="displayFormat">
                </div>
                <div *ngIf="isAllowSort" class="col-sm-4">
                    <label>Allow Sort : </label>
                </div>
                <div *ngIf="isAllowSort" class="col-sm-8">
                    <input class="form-check-input position-static" type="checkbox" formControlName="allowSort" style="margin-left: 0px;">
                </div>
                <div *ngIf="isAllowEdit" class="col-sm-4">
                    <label>Allow Edit : </label>
                </div>
                <div *ngIf="isAllowEdit" class="col-sm-8">
                    <input class="form-check-input position-static" type="checkbox" formControlName="isEditable" style="margin-left: 0px;">
                </div>
                <div class="col-sm-12">
                    <button type="button" class="btn btn-sm btn-secondary"
                        (click)="updateFormValues(dynaHeaderForm.value,'update')">Update</button>
                </div>
            </div>
        </form>-->
<div class="row">
    <div class="col-md-6">
        <table  class="table  table-sm">
            <thead class="dragula-thead">
                <th>
                    Available
                </th>
            </thead>
            <tbody class="dragula-tbody" [dragula]='"entity-items"' id="AvailableItems">
                <tr id="ai">
                    <td></td>
                </tr>
                <tr [id]="ah.Name" *ngFor="let ah of availableHeaders">
                    <td>{{ah.DisplayName}}
                        <span style="visibility:hidden" id="{{headerCode}}{{ah.Name}}">
                            <button class="btn btn-xs btn-secondary"
                                (click)="editdynaEditorItem(ah)">
                                <i id="button_DynaEdit" style="color:white"></i>
                            </button>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="col-md-6">
        <table  class="table  table-sm">
            <thead class="dragula-thead">
                <th>
                    Visible
                </th>
            </thead>
            <tbody class="dragula-tbody" [dragula]='"entity-items"' id="VisibleItems">
                <tr id="vi">
                    <td></td>
                </tr>
                <tr [id]="vh.Name" *ngFor="let vh of visibleHeaders">
                    <td>{{vh.DisplayName}}
                        <span id="{{headerCode}}{{vh.Name}}">
                            <button class="btn btn-sm btn-secondary"
                                (click)="editdynaEditorItem(vh)">
                                <i id="button_DynaEdit" style="color:white"></i>
                            </button>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>          
    </div>
</div>
